import { orchestrator } from 'satcheljs';
import { internalCloseSxS, updateSigsInfo } from '../actions/internalActions';
import { closeSxS } from '../actions/publicActions';
import getOrCreateSxSStoreData from '../store/Store';
import sendPreviewedAttachmentSigs from '../utils/sendPreviewedAttachmentSigs';

orchestrator(internalCloseSxS, actionMessage => {
    const { sxsId } = actionMessage;
    closeSxS();
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (sxsStore.sigsInfo) {
        sendPreviewedAttachmentSigs(sxsStore.sigsInfo);
        updateSigsInfo(null, sxsId);
    }
});
